import React from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

const SimpleTooltip = function ({
  hasWrapper,
  content,
  handleWrapperClick,
  title,
  isFormClass,
  position,
  isDummy,
}) {
  const classes = cn(
    'help',
    'js-help-parent',
    { help__form: isFormClass },
    { help__active: true },
    { dummy: isDummy },
  );
  return (
    <div className={classes}>
      <div className={cn('help_block', 'js-help-block', `help_block__${position}`)}>
        <div onClick={handleWrapperClick} className="help_wrapper">
          {title !== null ? <div className="help_title text-big">{title}</div> : title}
          {hasWrapper ? <div>{content}</div> : content}
        </div>
      </div>
    </div>
  );
};

SimpleTooltip.propTypes = {
  hasWrapper: PropTypes.bool,
  content: PropTypes.node,
  handleWrapperClick: PropTypes.func,
  title: PropTypes.string,
  isFormClass: PropTypes.bool,
  isDummy: PropTypes.bool,
  position: PropTypes.string,
};

export default SimpleTooltip;
